import { Component, Input } from '@angular/core';
import { Sourcefounding } from '../../../../core/models/sourcefounding.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SourcefoundingService } from '../../../../core/services/sourcefounding/sourcefounding-service';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { SourcefoundingForm } from '../sourcefounding-form/sourcefounding-form';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { AsyncPipe } from '@angular/common';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';

@Component({
  selector: 'app-sourcefounding-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
  ],
  templateUrl: './sourcefounding-list.html',
  styleUrl: './sourcefounding-list.scss',
})
export class SourcefoundingList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  private sectorName: string | null = null;
  foundingsources: Sourcefounding[] = [];
  asyncfoundingsources!: Observable<Sourcefounding[]>;
  buscarsourcefounding: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = ['acciones', 'id', 'name', 'description', 'term'];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private sourcefoundingService: SourcefoundingService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('fuentes de financiación');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchSourcefounding(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();

    this.layoutService.sectorSelected$.subscribe((sector) => {
      this.sectorName = sector?.name ?? null;
      this.fetchSourcefounding(1);
    });
  }

  fetchSourcefounding(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    const sectorName = this.layoutService.getSectorSelected()?.name;
    if (sectorName) {
      params.filters.push({ name: 'sector', value: sectorName } as Filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncfoundingsources = this.sourcefoundingService.getFoundingsources(params).pipe(
      tap((data) => {
        this.foundingsources = data.results;
        this.sourcefoundingService.setSourcefounding(data.results[0]);
        this.sourcefoundingService.setfoundingsources(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createSourcefounding() {
    this.sourcefoundingService.removeSourcefoundingSelected();
    const dialogRef = this.dialog.open(SourcefoundingForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchSourcefounding(this.page);
    });
  }

  updateSourcefounding(sourcefounding: Sourcefounding) {
    this.sourcefoundingService.setSourcefounding(sourcefounding);
    const dialogRef = this.dialog.open(SourcefoundingForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchSourcefounding(this.page);
    });
  }

  eliminate(sourcefounding: Sourcefounding): void {
    const confirmed = window.confirm(
      `¿Estás seguro de eliminar el registro: ${sourcefounding.name}?`,
    );
    if (!confirmed) return;
    this.sourcefoundingService.delete(sourcefounding.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchSourcefounding(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
